// import Actions from './Listing/Authorised/Actions';
import { Avatar } from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { EyeIcon } from "@/Components/Icons/EyeIcon";
import TimesheetMoreInfoModal from "@/Components/modals/client/TimesheetMoreInfoModal";
import { routingConstants } from "@/Constants/routingConstants";
import {
  fetchTerminatedTimesheets,
  toggleTimesheetMoreInfoModal,
  updateSelectedCandidate,
  updateSelectedSignOffIds,
  updateToggleSelected,
  updateViewMoreInfo,
  toggleSelectedAll,
  updateSorting,
  updatePagination,
  deSelectAllCandidate,
  setTerminatedTimesheetsLoading,
  updateSelectedTimesheets,
} from "@/reducers/timesheets/timesheetterminated";
import {
  getActionByHtml,
  getColumnNormalHtml,
} from "@/utilities/datatable/columnFunctions";
import useDebounceScroll from "@/utilities/hooks/useDebounceScroll";
import { getComplianceClass, getWorkedStatusClasses } from "@/utilities/utils";

import TableLoader from "../../TableLoader";
import TableNoContent from "../../TableNoContent";
import BlurredText from "../managedService/BlurredText";
import Actions from "./Listing/Terminated/Actions";
import { FilterModal } from "./Listing/Terminated/FilterModal";
import SearchFilter from "./Listing/Terminated/SearchFilter";
import DataTablePaginationLoader from "../../../Skeletons/DataTablePaginationLoader";
import { Miles } from "../candidates/Listing/common/Miles";
import { SelectedCountText } from "../candidates/Listing/common/SelectedCountText";
import CandidateStatusAndInfo from "../dataTables/CandidateStatusAndInfo";

const TerminatedList = () => {
  const dispatch = useDispatch();
  const {
    selectedCandidate,
    toggleSelected,
    isLoading,
    pagination,
    terminatedTimesheets,
    totalCount,
    isSelectedAll,
    isPaginationLoading,
    sorting,
  } = useSelector((state) => state.clientTimesheetTerminated);
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (selectedCandidate.length == 0) {
      dispatch(updateToggleSelected());
    }
  }, [selectedCandidate]);
  useEffect(() => {
    setData(terminatedTimesheets);
  }, [terminatedTimesheets]);
  const columns = [
    {
      name: "Candidate",
      sortable: true,
      sortField: "candidate_forename",

      // sortFunction: (rowA, rowB) => sortByText(rowA, rowB, "candidate_name"),
      selector: (row) => (
        <div className="flex gap-[14px]">
          <div className="min-w-[45px]">
            <Avatar
              alt={row.candidate_name}
              sx={{ width: 45, height: 45 }}
              src={row.profile_image ? row.profile_image : ""}
            />
          </div>
          <div className="flex grow flex-col gap-1 overflow-hidden">
            {!clientUserAllPermissions ||
            clientUserAllPermissions.is_allow_to_view_candidate_profile ===
              1 ? (
              <>
                <Link
                  to={routingConstants.candidateDetail(row.route_id)}
                  className="truncate text-[14px] font-semibold leading-[normal] text-black"
                >
                  {row.candidate_name}
                </Link>
              </>
            ) : (
              <span className="cursor-default truncate text-[14px] font-semibold leading-[normal] text-black">
                {row.candidate_name}
              </span>
            )}

            <CandidateStatusAndInfo
              sortlisted={row.candidate_sortlisted}
              unsuitable={row.candidate_unsuitable}
              is_auto_booked_on_apply={row.is_auto_booked_on_apply}
              extraEle={
                !clientUserAllPermissions ||
                clientUserAllPermissions.is_allow_to_view_contract_detail ===
                  1 ? (
                  <>
                    <Link
                      to={routingConstants.contractDetail(
                        row.route_contract_id,
                      )}
                      className="line-clamp-1 text-[12px] font-medium leading-[normal] text-txtColor"
                    >
                      {row.contract_ref_no}
                    </Link>
                  </>
                ) : (
                  <span className="line-clamp-1 cursor-default text-[12px] font-medium leading-[normal] text-txtColor">
                    {row.contract_ref_no}
                  </span>
                )
              }
            />
          </div>
        </div>
      ),
      width: "17%",
    },
    {
      name: "Contact",
      sortable: true,
      sortField: "candidate_email",
      selector: (row) => (
        <div className="flex flex-col">
          <BlurredText type="phone">
            {getColumnNormalHtml(row.mobile_phone_number, "truncate")}
          </BlurredText>
          <BlurredText type="email">
            {getColumnNormalHtml(row.candidate_email, "truncate")}
          </BlurredText>
        </div>
      ),
      width: "14%",
    },
    {
      name: "Miles",
      sortable: false,
      selector: (row) => <Miles miles={row.miles} />,
      width: "8%",
    },
    {
      name: "Role",
      sortable: true,
      sortField: "role_name",
      selector: (row) => (
        <div className="flHappy Birthday :partying_face::birthday:ex flex-col">
          {getColumnNormalHtml(
            row.role_name,
            "line-clamp-2 whitespace-break-spaces",
          )}
          <span className="text-[12px] font-medium leading-[normal] text-txtColor">
            {row.license_number}
          </span>
        </div>
      ),
      width: "8%",
    },
    {
      name: "Terminated by",
      sortable: false,
      selector: (row) => (
        <div className="flex flex-col" data-tag="allowRowEvents">
          {getActionByHtml(
            row.rejected_or_terminated_by || "-",
            row.rejected_or_terminated_at,
            row?.rejected_or_terminated_user_from,
            "",
          )}
        </div>
      ),
      width: "13.6%",
    },
    {
      name: "Shift Date",
      sortable: true,
      sortField: "timesheet_date",
      selector: (row) => (
        <div className="flex flex-col">
          {getColumnNormalHtml(
            moment(row.shift_date, "DD/MM/YYYY").format("DD/MM/YYYY"),
          )}
          <span
            className={`h-[23px] w-[75px] rounded-[4px] text-center text-[14px] font-medium leading-[23px] ${getComplianceClass(
              row.profile_percent,
            )}`}
          >
            {row.profile_percent == "-" ? "0%" : row.profile_percent + "%"}
          </span>
        </div>
      ),
      width: "90px",
    },
    {
      name: "Shift",
      sortable: false,
      selector: (row) => (
        <div className="flex flex-col items-end gap-1">
          {getColumnNormalHtml(
            moment(row.start_time, "HH:mm:ss").format("HH:mm"),
          )}
          <span className="text-[14px] font-semibold leading-[0px] text-black">
            -
          </span>
          {getColumnNormalHtml(
            moment(row.end_time, "HH:mm:ss").format("HH:mm"),
          )}
        </div>
      ),
      width: "55px",
    },
    {
      name: "Break/Admin",
      sortable: false,
      selector: (row) => (
        <div className="flex flex-col items-end gap-1">
          {getColumnNormalHtml(
            moment(row.break_time, "HH:mm:ss").format("HH:mm"),
          )}
          <span className="text-[14px] font-semibold leading-[0px] text-black">
            -
          </span>
          {getColumnNormalHtml(
            moment(row.admin_time, "HH:mm:ss").format("HH:mm"),
          )}
        </div>
      ),
      width: "8.5%",
    },
    {
      name: "Status",
      sortable: true,
      sortField: "timesheet_status",
      selector: (row) => (
        <div className="flex flex-col items-end gap-1">
          <span
            className={`h-[24px] rounded-md border px-2 pb-[24px] text-[14px] font-medium leading-[24px] ${getWorkedStatusClasses(row.timesheet_status)}`}
          >
            {row.timesheet_status}
          </span>
        </div>
      ),
      width: "9%",
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex flex-col items-end gap-1">
          <button
            onClick={() => {
              const {
                reject_or_terminate_reason: reason,
                rejected_or_terminated_by: terminated_by,
                rejected_or_terminated_user_dept: user_department,
                rejected_or_terminated_user_type: user_type,
                terminated_candidate_name: terminated_candidate_name,
                timesheet_status: status,
                is_proposed_timesheet,
                cover_by_candidate_id,
                cover_by_candidate_name,
                cover_by_contract_id,
                cover_by_contract_ref,
              } = row;
              const obj = {
                reason,
                terminated_by,
                user_department,
                user_type,
                status,
                terminated_candidate_name,
                is_proposed_timesheet,
                cover_by_candidate_id,
                cover_by_candidate_name,
                cover_by_contract_id,
                cover_by_contract_ref,
              };
              dispatch(toggleTimesheetMoreInfoModal(true));
              dispatch(updateViewMoreInfo(obj));
            }}
          >
            <EyeIcon cls="ml-4 w-[20px] h-[20px] text-[#1A1A1A]" />
          </button>
        </div>
      ),
      width: "auto",
    },
  ];
  const dataTableRef = useRef();

  const handleDebounceScroll = useDebounceScroll(() =>
    dispatch(fetchTerminatedTimesheets({})),
  );
  useEffect(() => {
    if (dataTableRef.current) {
      const table = dataTableRef.current.querySelector("._DataTable");
      table.addEventListener("scroll", handleDebounceScroll);
      return () => {
        table.removeEventListener("scroll", handleDebounceScroll);
      };
    }
  }, [handleDebounceScroll]);

  const handleSort = ({ sortField: newSortField }) => {
    const { sortByColumn, sortByOrder } = sorting; // get from Redux

    let newSortOrder = "asc";
    if (sortByColumn === newSortField) {
      newSortOrder = sortByOrder === "asc" ? "desc" : "asc";
    }

    dispatch(
      updateSorting({ sortByColumn: newSortField, sortByOrder: newSortOrder }),
    );
    dispatch(deSelectAllCandidate());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setTerminatedTimesheetsLoading(true));
    dispatch(fetchTerminatedTimesheets());
  };

  return (
    <div className="TerminatedList_Wrapper mb-[58px]">
      <div className="flex h-full flex-col rounded-[10px] bg-white p-4 shadow-[0px_x1px_6px_0px_#E7EFFB]">
        <div className="mb-[20px] flex flex-col flex-wrap gap-3 border-b border-b-[#E8E8E8] pb-[11px] md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-2 md:gap-[21px]">
            <h4 className="main-heading tour-terminated-heading font-medium leading-[normal] text-black">
              Disputed Timesheet
            </h4>
            <Actions />
            <SelectedCountText
              selectedCount={selectedCandidate.length}
              totalCount={totalCount}
              isSelectedAll={isSelectedAll}
              clearSelected={() => {
                dispatch(updateToggleSelected());
              }}
              handleSelectAll={(val) => {
                dispatch(toggleSelectedAll(val));
              }}
              updateSelected={(val) => {
                dispatch(updateSelectedCandidate(val));
                dispatch(updateSelectedTimesheets(val));
              }}
              currentDataLength={data.length}
            />
          </div>
          <div className="flex gap-[20px]">
            <SearchFilter />
            <FilterModal />
            <TimesheetMoreInfoModal />
          </div>
        </div>
        <div
          className="DataTable_Wrapper hide_extended_arrow"
          ref={dataTableRef}
        >
          <DataTable
            columns={columns}
            data={data}
            fixedHeader
            onSort={handleSort}
            // persistTableHead={true}
            fixedHeaderScrollHeight="600px"
            progressPending={isLoading}
            progressComponent={<TableLoader rows={5} />}
            selectableRows
            onSelectedRowsChange={(state) => {
              let selectedIDS = state.selectedRows.map((item) => {
                return item.candidate_id;
              });
              let selectedSignOff = state.selectedRows.map((item) => {
                return item.timesheet_id;
              });
              dispatch(updateSelectedCandidate(selectedIDS));
              dispatch(updateSelectedSignOffIds(selectedSignOff));
              dispatch(updateSelectedTimesheets(state.selectedRows));
            }}
            noDataComponent={<TableNoContent rows={5} />}
            clearSelectedRows={toggleSelected}
            // expandableRows
            // expandOnRowClicked
            // expandableRowsComponent={Expandedrow}
            className="_DataTable"
          />
        </div>
        {!isLoading && isPaginationLoading ? (
          <DataTablePaginationLoader />
        ) : null}
      </div>
    </div>
  );
};

export default TerminatedList;
